import { render } from "./RiskMapReports.vue?vue&type=template&id=d6487596&scoped=true&ts=true"
import script from "./RiskMapReports.vue?vue&type=script&lang=ts"
export * from "./RiskMapReports.vue?vue&type=script&lang=ts"

import "./RiskMapReports.vue?vue&type=style&index=0&id=d6487596&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6487596"]])

export default __exports__